import React from "react";
import { UI } from "@wwimmo/ui";
import { NavigationbarItem } from "src/components/header/navigationbar/NavigationbarItem";
import { observer } from "mobx-react";
import "./Navigationbar.css";

interface NavigationbarProps {
    navLinks: { to: string; label: string; icon: React.ReactNode }[];
}

const NavigationbarBase = (props: NavigationbarProps) => {
    const { navLinks } = props;
    return (
        <UI.Nav className="Navigationbar">
            <UI.Container>
                <UI.Row className="NavigationbarContainer">
                    {navLinks.map((navLink, index) => (
                        <NavigationbarItem
                            key={`item-${index}`}
                            label={navLink.label}
                            to={navLink.to}
                            icon={navLink.icon}
                        />
                    ))}
                </UI.Row>
            </UI.Container>
        </UI.Nav>
    );
};

export const Navigationbar = observer(NavigationbarBase);
